import { futureVision } from "@/mocks/homeData";

export default function VisionSection() {
  return (
    <section id="vision" className="relative w-full bg-navy-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="animate-on-scroll text-center mb-12 md:mb-16">
            <p className="text-sky-500 text-sm font-semibold tracking-wider uppercase mb-3">
              Future Vision
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-navy-900">
              향후 비전
            </h2>
            <p className="text-navy-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
              2026년부터 2029년까지의 성장 로드맵과 비전을 제시합니다
            </p>
          </div>

          <div className="relative">
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-sky-200 -translate-x-1/2" />
            <div className="hidden md:block absolute left-1/2 top-0 w-3 h-3 bg-sky-400 rounded-full -translate-x-1/2 -translate-y-1/2" />
            <div className="hidden md:block absolute left-1/2 bottom-0 w-3 h-3 bg-sky-400 rounded-full -translate-x-1/2 translate-y-1/2" />

            <div className="space-y-8 md:space-y-0">
              {futureVision.map((item, index) => {
                const isLeft = index % 2 === 0;
                return (
                  <div
                    key={index}
                    className={`animate-on-scroll ${['delay-100','delay-200','delay-300','delay-400'][index] || 'delay-100'} relative md:grid md:grid-cols-2 md:gap-8 md:items-center ${index > 0 ? 'md:mt-8' : ''}`}
                  >
                    <div
                      className={`${isLeft ? 'md:text-right md:pr-8' : 'md:order-2 md:pl-8 md:text-left'}`}
                    >
                      <div className={`bg-white rounded-xl p-5 md:p-6 border border-navy-100 inline-block w-full ${isLeft ? 'md:text-right' : ''}`}>
                        <span className="inline-block px-3 py-1 bg-sky-500 text-white text-sm font-bold rounded-full mb-3">
                          {item.year}
                        </span>
                        <h3 className="text-base md:text-lg font-bold text-navy-900 mb-2">
                          {item.title}
                        </h3>
                        <p className="text-sm text-navy-500 leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>

                    <div className={`hidden md:flex justify-center ${isLeft ? 'md:order-2' : ''}`}>
                      <div className="relative">
                        <div className="w-4 h-4 bg-sky-400 rounded-full border-4 border-white shadow-md z-10 relative" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}